$(document).ready(function(){
    /**
     * #9631, copie les erreurs du formulaire de création et les affiche
     * avant meme de cliquer sur "Créer mon compte"
     * 
     * Commenté à partir de la #10324
     */
    // if ($('.js-customer-form .help-block').length > 0) {
    //     $('.js-customer-form .help-block').each(function() {
    //         $(this).clone().prependTo($('#checkout-personal-information-step .checkout-step__content'));
    //     });
    // }
});